const initialState = {
    data: [],
  };
  
  const mieszkancyAllReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_MIESZKANCY_ALL':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default mieszkancyAllReducer;